var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6669 14.9334L13.0669 7.46668C12.5336 6.93335 11.7336 6.93335 11.2002 7.46668C10.6669 8.00002 10.6669 8.80002 11.2002 9.33335L17.7336 16L11.2002 22.6667C10.6669 23.2 10.6669 24 11.2002 24.5333C11.4669 24.8 11.7336 24.9333 12.1336 24.9333C12.5336 24.9333 12.8002 24.8 13.0669 24.5333L20.6669 17.0667C21.2002 16.4 21.2002 15.6 20.6669 14.9334C20.6669 15.0667 20.6669 15.0667 20.6669 14.9334Z",
    fill: "#51459E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.6d0b4e933b5955d00d2f11b5d3223dab.svg";
export { ForwardRef as ReactComponent };